var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTarget = function SvgIconTarget(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.536 2.005a10.01 10.01 0 1 0 8.84 6.516 1 1 0 0 0-1.876.695 8.01 8.01 0 1 1-2.592-3.538l-1.795 1.795a5.49 5.49 0 1 0 .768 8.416 5.4 5.4 0 0 0 1.515-2.802 1 1 0 1 0-1.961-.392 3.4 3.4 0 0 1-.958 1.77l-.006.005a3.49 3.49 0 1 1-.812-5.544l-2.366 2.367a1 1 0 0 0 1.414 1.414l6.352-6.352.027-.027 2.621-2.62a1 1 0 0 0-1.414-1.415L18.33 4.255a10 10 0 0 0-5.795-2.25",
    clipRule: "evenodd"
  })));
};
export default SvgIconTarget;